import React, { useState, useEffect } from "react";
import { API_URL } from "../../constant";
import { useNavigate } from "react-router-dom";
import { FaCheckCircle, FaExclamationCircle } from "react-icons/fa";
import '../MiniAgentReferralHistoty/MiniAgentReferralHistory.css';
import WalletCard from "../../components/RetailerBusinessAgent/WallertCard";
import wallet1 from "../../images/shapes/Wallet01 5.png";
import wallet2 from "../../images/shapes/Wallet03.1 1.png";
import dollarG from "../../images/shapes/Dollar Bag.png";
import dollarY from "../../images/shapes/Dollar Bag (1).png";
import history1 from "../../images/shapes/Group 37483.png";

const CashbackRequests = () => {
  const [eligibleCustomers, setEligibleCustomers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [processingId, setProcessingId] = useState(null);
  const [message, setMessage] = useState({ text: "", type: "" });
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const navigate = useNavigate();

  const fetchEligible = async (page = 1) => {
    try {
      const token = localStorage.getItem("account_admin_token");
      const response = await fetch(`${API_URL}/api/account-admin/eligible-cashback?page=${page}&per_page=10`, {
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      });
      if (response.ok) {
        const data = await response.json();
        if (data && data.data) {
          setEligibleCustomers(data.data);
          setTotalPages(data.last_page || 1);
        } else if (Array.isArray(data)) {
          setEligibleCustomers(data);
          setTotalPages(1);
        } else {
          setEligibleCustomers([]);
          setTotalPages(1);
        }
      }
    } catch (err) {
      console.error("Failed to load eligible customers");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchEligible(currentPage);
  }, [currentPage]);

  const handleProcess = async (requestId, hasFullAddress) => {
    if (!hasFullAddress) {
      setMessage({
        text: "Cannot process: Customer does not have a full address. Please request that they provide a full address on their portal.",
        type: "error"
      });
      return;
    }

    setProcessingId(requestId);
    setMessage({ text: "", type: "" });

    try {
      const token = localStorage.getItem("account_admin_token");
      const response = await fetch(`${API_URL}/api/account-admin/process-cashback`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({
          request_id: requestId,
          action: "approve"
        }),
      });

      const data = await response.json();
      if (response.ok) {
        setMessage({ text: data.message || "Processed successfully!", type: "success" });
        fetchEligible(currentPage); // Refresh list
      } else {
        setMessage({ text: data.message || "Failed to process.", type: "error" });
      }
    } catch (err) {
      setMessage({ text: "An error occurred.", type: "error" });
    } finally {
      setProcessingId(null);
    }
  };

  return (
    <div className="customer-referral-history-container">
      {/* <h2 style={{ color: "#333", marginBottom: "30px", fontSize: "2rem", fontWeight: "bold" }}>
        Eligible Cashback Requests
      </h2> */}

      {message.text && (
        <div
          style={{
            padding: "15px",
            marginBottom: "20px",
            borderRadius: "8px",
            backgroundColor: message.type === "error" ? "#fdecea" : "#e8f5e9",
            color: message.type === "error" ? "#d32f2f" : "#2e7d32",
            display: "flex",
            alignItems: "center",
            gap: "10px",
            boxShadow: "0 4px 15px rgba(0,0,0,0.1)"
          }}
        >
          {message.type === "error" ? <FaExclamationCircle /> : <FaCheckCircle />}
          {message.text}
        </div>
      )}

      <div style={{ background: "#fff", borderRadius: "12px", overflow: "hidden", boxShadow: "0 4px 15px rgba(0,0,0,0.1)", padding: "8px" }}>
        {loading ? (
          <div className="loading-container" style={{ margin: "40px auto" }}>
              <div className="loading-spinner" style={{ borderColor: "#001964 transparent #001964 transparent" }}></div>
              <p style={{ marginTop: '10px', color: "#333" }}>Loading requests...</p>
          </div>
        ) : eligibleCustomers.length === 0 ? (
          <div className="empty-state" style={{ margin: "40px auto", color: "#333" }}>
            <div className="empty-icon">📊</div>
            <h3 style={{ color: "#333" }}>No Pending Requests Found</h3>
            <p style={{ color: "#666" }}>There are no eligible cashback requests at the moment.</p>
          </div>
        ) : (
          <>
            <div className="table-responsive">
              <table className="user-table">
                <thead>
                  <tr>
                    <th>Customer</th>
                    <th>Email</th>
                    <th style={{ textAlign: "center" }}>Captain TC Promotion (TC)</th>
                    <th style={{ textAlign: "center" }}>Eligible Value</th>
                    <th style={{ textAlign: "center" }}>Address Status</th>
                    <th style={{ textAlign: "center" }}>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {eligibleCustomers.map((item) => (
                    <tr 
                      key={item.request_id}
                      style={{ cursor: "pointer" }}
                      onClick={() => navigate(`/account-admin/requests/${item.request_id}`, { state: { item } })}
                      className="hover-row"
                    >
                      <td className="name-cell">
                        {item.customer?.first_name} {item.customer?.last_name}
                      </td>
                      <td>{item.customer?.email}</td>
                      <td style={{ textAlign: "center", fontWeight: "bold" }}>{item.extra_card_balance} TC</td>
                      <td style={{ textAlign: "center", fontWeight: "bold" }}>{(item.available_cashback_gbp / 0.005).toFixed(0)} TC</td>
                      <td style={{ textAlign: "center" }}>
                        {item.has_full_address ? (
                          <span className="status-badge active" style={{ display: "inline-block", background: "#e8f5e9", color: "#2e7d32" }}>
                            Complete
                          </span>
                        ) : (
                          <span className="status-badge pending" style={{ display: "inline-block", background: "#fdecea", color: "#d32f2f" }}>
                            Incomplete
                          </span>
                        )}
                      </td>
                      <td style={{ textAlign: "center" }}>
                        <button
                          onClick={(e) => {
                            e.stopPropagation();
                            handleProcess(item.request_id, item.has_full_address);
                          }}
                          disabled={processingId === item.request_id}
                          style={{
                            background: item.has_full_address ? "#001964" : "#ccc",
                            color: "#fff",
                            border: "none",
                            padding: "8px 16px",
                            borderRadius: "8px",
                            cursor: item.has_full_address ? "pointer" : "not-allowed",
                          }}
                        >
                          {processingId === item.request_id ? "Processing..." : "Approve Request"}
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            {totalPages > 1 && (
              <div className="pagination-container" style={{ marginTop: '20px' }}>
                <div className="pagination">
                  <button 
                    className="page-btn prev-next" 
                    onClick={() => setCurrentPage((p) => p - 1)}
                    disabled={currentPage === 1}
                  >
                    ←
                  </button>
                  
                  <div className="page-numbers">
                    {Array.from({ length: Math.min(totalPages, 5) }, (_, i) => {
                      let pageNum;
                      if (totalPages <= 5) {
                        pageNum = i + 1;
                      } else if (currentPage <= 3) {
                        pageNum = i + 1;
                      } else if (currentPage >= totalPages - 2) {
                        pageNum = totalPages - 4 + i;
                      } else {
                        pageNum = currentPage - 2 + i;
                      }
                      
                      return (
                        <button
                          key={i}
                          className={`page-btn ${currentPage === pageNum ? "active" : ""}`}
                          onClick={() => setCurrentPage(pageNum)}
                        >
                          {pageNum}
                        </button>
                      );
                    })}
                  </div>
                  
                  <button 
                    className="page-btn prev-next" 
                    onClick={() => setCurrentPage((p) => p + 1)}
                    disabled={currentPage === totalPages}
                  >
                    →
                  </button>
                </div>
                
                <div className="page-info">
                  Page {currentPage} of {totalPages}
                </div>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default CashbackRequests;
